import { useCallback, useEffect, useState } from 'react';
import { useMutation } from 'react-apollo';
import { useDispatch } from 'react-redux';

import { externalShippingAddressesCreate as externalShippingAddressesCreateMutation } from '../../../../graphql/mutations/externalShippingAddress';
import { openAlert } from '../../../../actions/modal-actions';
import { sentryCaptureMessage } from '../../../../util/sentry';
import { getErrorString } from '../../../../util/normalize-errors';
import getUserForAccountCardConfigurationQuery from '../../graphql/queries/getUserForAccountCardConfiguration';

const useBulkExternalShippingAddressImport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [externalShippingAddressesCreate] = useMutation(
    externalShippingAddressesCreateMutation,
  );
  const dispatch = useDispatch();
  const onErrorModalOpen = useCallback(
    state => dispatch(openAlert(state)),
    [dispatch],
  );

  const onImport = async data => {
    if (loading) {
      return;
    }

    setLoading(true);
    setError('');

    try {
      const serializedData = JSON.parse(data);
      await externalShippingAddressesCreate({
        variables: {
          input: {
            external_shipping_addresses: serializedData,
            skip_errors: true,
            ignore_errors: true,
          },
        },
        refetchQueries: [
          {
            query: getUserForAccountCardConfigurationQuery,
          },
        ],
      });
    } catch (responseError) {
      sentryCaptureMessage(
        responseError?.message ??
          '[AccountCard Native Import] :: Error Importing',
        {
          level: 'error',
          error: responseError,
        },
      );

      setError(getErrorString(responseError));
      onErrorModalOpen({
        message: 'There was an error during import, please try again.',
        info: responseError?.request_id || getErrorString(responseError),
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.waldoApps = {
      ...window.waldoApps,
      onCardContactsSelectedForImport: data => {
        onImport(data);
      },
    };
  }, []);

  return {
    loading,
    error,
  };
};

export default useBulkExternalShippingAddressImport;
